module.exports = __webpack_public_path__ + "static/media/p3.a7935c54.webp";